import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);

/** Spec §1.4/§7.3: horário local de São Paulo na tela, UTC no tooltip. Execução às 23:00 conta no dia dela. */
const SAO_PAULO_TZ = "America/Sao_Paulo";

export function formatSaoPauloDateTime(iso: string): string {
  return dayjs(iso).tz(SAO_PAULO_TZ).format("DD/MM HH:mm");
}

export function formatSaoPauloDate(iso: string): string {
  return dayjs(iso).tz(SAO_PAULO_TZ).format("DD/MM/YYYY");
}

export function formatUtcTooltip(iso: string): string {
  return `${dayjs(iso).utc().format("DD/MM/YYYY HH:mm")} UTC`;
}

export function daysSinceInSaoPaulo(iso: string, now: Date = new Date()): number {
  const today = dayjs(now).tz(SAO_PAULO_TZ).startOf("day");
  const reference = dayjs(iso).tz(SAO_PAULO_TZ).startOf("day");
  return today.diff(reference, "day");
}
